import React, { Component, useState } from 'react';
import { connect } from 'react-redux';
import { t } from '../../../../locales';
import moment from 'moment';
import './styles.scss';
import Dropdown from '@axa-asia/emma-stylesheet/lib/components/Dropdown/Dropdown';
import { validateDateOfBirth } from '../../../../utils';

export interface OffersFormDependentViewProps {
  formDependentConfig: any;
  dependentIndex: any;
  dependentArr: any;
  offersData: any;
  reduceDependent: (reduceIndex: number) => void;
  changeDependent: (dependentArr: Array<any>) => void;
}

export interface OffersFormDependentViewState {
  // Relationship
  isShowRelationshipOptionList: boolean;
  relationshipState: string;
  relationshipOptionList: Array<any>;
  // Full name
  nameState: string;
  isShowNameError: boolean;
  isShowNameCorrect: boolean;
  // Gender
  isShowGenderOptionList: boolean;
  genderState: string;
  genderOptionList: Array<any>;
  // Date of Birth
  isShowDateOptionList: boolean;
  date: string;
  dateOptionList: Array<any>;
  isShowMonthOptionList: boolean;
  month: string;
  monthOptionList: Array<any>;
  isShowYearOptionList: boolean;
  year: string;
  yearOptionList: Array<any>;
  errorMsgDOB: string;
  isShowRelationshipError: boolean;
  isShowGenderError: boolean;
}

export class OffersFormDependentView extends Component<
  OffersFormDependentViewProps,
  OffersFormDependentViewState
> {
  constructor(props: any = {}) {
    super(props);

    const denpendentData =
      props.offersData &&
      props.offersData.dependentArr &&
      props.offersData.dependentArr.length > 0
        ? props.offersData.dependentArr[props.dependentIndex]
        : {};
    this.state = {
      // Relationship
      isShowRelationshipOptionList: false,
      relationshipState:
        denpendentData && denpendentData.relationship
          ? denpendentData.relationship
          : '',
      relationshipOptionList: [
        {
          optionVal: `${t('RELATIONSHIP_SPOUSE_OPTION')}`,
          optionTitle: `${t('RELATIONSHIP_SPOUSE_OPTION')}`,
        },
        {
          optionVal: `${t('RELATIONSHIP_CHILD_OPTION')}`,
          optionTitle: `${t('RELATIONSHIP_CHILD_OPTION')}`,
        },
        {
          optionVal: `${t('RELATIONSHIP_PARENT_OPTION')}`,
          optionTitle: `${t('RELATIONSHIP_PARENT_OPTION')}`,
        },
        {
          optionVal: `${t('RELATIONSHIP_PARENT_IN_LAW_OPTION')}`,
          optionTitle: `${t('RELATIONSHIP_PARENT_IN_LAW_OPTION')}`,
        },
      ],
      // Full name
      nameState:
        denpendentData && denpendentData.fullName
          ? denpendentData.fullName
          : '',
      isShowNameError: false,
      isShowNameCorrect: false,
      // Gender
      isShowGenderOptionList: false,
      genderState:
        denpendentData && denpendentData.gender ? denpendentData.gender : '',
      genderOptionList: [
        {
          optionVal: `${t('GENDER_MALE_OPTION')}`,
          optionTitle: `${t('GENDER_MALE_OPTION')}`,
        },
        {
          optionVal: `${t('GENDER_FEMALE_OPTION')}`,
          optionTitle: `${t('GENDER_FEMALE_OPTION')}`,
        },
      ],
      // Date of Birth
      isShowDateOptionList: false,
      date:
        denpendentData && denpendentData.birthday
          ? moment(denpendentData.birthday).format('DD')
          : '',
      dateOptionList: [
        {
          optionVal: '',
          optionTitle: '',
        },
      ],
      isShowMonthOptionList: false,
      month:
        denpendentData && denpendentData.birthday
          ? moment(denpendentData.birthday).format('MM')
          : '',
      monthOptionList: [
        {
          optionVal: '',
          optionTitle: '',
        },
      ],
      isShowYearOptionList: false,
      year:
        denpendentData && denpendentData.birthday
          ? moment(denpendentData.birthday).format('YYYY')
          : '',
      yearOptionList: [
        {
          optionVal: '',
          optionTitle: '',
        },
      ],
      errorMsgDOB: '',
      isShowRelationshipError: false,
      isShowGenderError: false,
    };
    this.reduceDependentForm = this.reduceDependentForm.bind(this);
    this.onBlurInputName = this.onBlurInputName.bind(this);
    this.setGenderOpenOption = this.setGenderOpenOption.bind(this);
    this.setRelationshipOpenOption = this.setRelationshipOpenOption.bind(this);
    this.setDateOpenOption = this.setDateOpenOption.bind(this);
    this.setMonthOpenOption = this.setMonthOpenOption.bind(this);
    this.setYearOpenOption = this.setYearOpenOption.bind(this);
    this.onBlurRelationshipOption = this.onBlurRelationshipOption.bind(this);
    this.onBlurGenderOption = this.onBlurGenderOption.bind(this);
  }

  componentDidMount() {
    this.dateCombo();
    this.monthCombo();
    this.yearCombo();

    const { relationshipState, nameState, genderState, date, month, year } =
      this.state;
    const { dependentIndex, dependentArr, changeDependent } = this.props;
    if (dependentArr && dependentIndex && dependentArr[dependentIndex]) {
      dependentArr[dependentIndex]['relationship'] = relationshipState;
      dependentArr[dependentIndex]['name'] = nameState;
      dependentArr[dependentIndex]['gender'] = genderState;
      dependentArr[dependentIndex]['birthday'] = `${year}${month}${date}`;
      changeDependent(dependentArr);
    }
  }

  componentWillReceiveProps(nextProps: OffersFormDependentViewProps) {
    if (nextProps.dependentArr && nextProps.dependentArr.length > 0) {
      const nextDependent = nextProps.dependentArr[nextProps.dependentIndex];
      const { date, month, year } = this.state;
      this.setState({
        relationshipState:
          nextDependent && nextDependent['relationship']
            ? nextDependent['relationship']
            : '',
        nameState:
          nextDependent && nextDependent['fullName']
            ? nextDependent['fullName']
            : '',
        genderState:
          nextDependent && nextDependent['gender']
            ? nextDependent['gender']
            : '',
        date:
          nextDependent && nextDependent['birthday']
            ? moment(nextDependent['birthday']).format('DD')
            : date,
        month:
          nextDependent && nextDependent['birthday']
            ? moment(nextDependent['birthday']).format('MM')
            : month,
        year:
          nextDependent && nextDependent['birthday']
            ? moment(nextDependent['birthday']).format('YYYY')
            : year,
      });
    }
  }

  reduceDependentForm() {
    const { dependentIndex, dependentArr, reduceDependent } = this.props;
    if (dependentArr && dependentArr.length > 0) {
      reduceDependent(dependentIndex);
    }
  }

  updateDependentArr(label: string, value: any) {
    const { dependentIndex, dependentArr, changeDependent } = this.props;
    dependentArr[dependentIndex][label] = value;
    changeDependent(dependentArr);
  }

  // Relationship
  setRelationshipOpenOption(val: any) {
    return this.setState({
      isShowRelationshipOptionList: val,
    });
  }
  chooseRelationshipOption(val: any) {
    this.setState({
      relationshipState: val,
      isShowRelationshipError: false,
    });
    this.updateDependentArr('relationship', val);
  }
  onBlurRelationshipOption(val: string) {
    val === '' &&
      this.setState({
        isShowRelationshipError: true,
      });
  }

  // Full name
  onBlurInputName(e: any) {
    let value = e.target.value;
    value = value.replace(/[^\u4E00-\u9FA5a-zA-Z\s]/g, '');
    if (value) {
      this.setState({
        isShowNameError: false,
        isShowNameCorrect: true,
      });
    } else {
      this.setState({
        isShowNameError: true,
        isShowNameCorrect: false,
      });
    }
    this.setState({ nameState: value });
    this.updateDependentArr('fullName', value);
  }

  // Gender
  setGenderOpenOption(val: any) {
    return this.setState({
      isShowGenderOptionList: val,
    });
  }
  chooseGenderOption(val: any) {
    this.setState({
      genderState: val,
      isShowGenderError: false,
    });
    this.updateDependentArr('gender', val);
  }

  onBlurGenderOption(val: string) {
    val === '' &&
      this.setState({
        isShowGenderError: true,
      });
  }

  // Date of Birth
  dateCombo() {
    const days = [];
    for (let i = 1; i <= 31; i++) {
      let dayString = i.toString();
      if (dayString.length === 1) {
        dayString = `0${dayString}`;
      }
      days.push({
        optionVal: dayString,
        optionTitle: dayString,
      });
    }
    this.setState({
      dateOptionList: days,
    });
  }
  monthCombo() {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      let monthString = i.toString();
      if (monthString.length === 1) {
        monthString = `0${monthString}`;
      }
      months.push({
        optionVal: monthString,
        optionTitle: monthString,
      });
    }
    this.setState({
      monthOptionList: months,
    });
  }
  yearCombo() {
    const years = [];
    const year = new Date().getFullYear();
    for (let i = year; i > year - 82; i--) {
      years.push({
        optionVal: i.toString(),
        optionTitle: i.toString(),
      });
    }
    this.setState({
      yearOptionList: years,
    });
  }

  setDateOpenOption(val: any) {
    return this.setState({
      isShowDateOptionList: val,
    });
  }
  chooseDateOption(val: any) {
    const { year, month } = this.state;
    const errorMsgDOB = validateDateOfBirth(year, month, val, 6);
    this.setState(
      {
        date: val,
      },
      () => {
        this.setState({
          errorMsgDOB: errorMsgDOB,
        });
        if (!errorMsgDOB) {
          const dob = moment(`${year}${month}${val}`).format('YYYYMMDD');
          this.updateDependentArr('birthday', dob);
        } else {
          this.updateDependentArr('birthday', '');
        }
      },
    );
  }
  setMonthOpenOption(val: any) {
    return this.setState({
      isShowMonthOptionList: val,
    });
  }
  chooseMonthOption(val: any) {
    const { year, date } = this.state;
    const errorMsgDOB = validateDateOfBirth(year, val, date, 6);
    this.setState(
      {
        month: val,
      },
      () => {
        this.setState({
          errorMsgDOB: errorMsgDOB,
        });
        if (!errorMsgDOB) {
          const dob = moment(`${year}${val}${date}`).format('YYYYMMDD');
          this.updateDependentArr('birthday', dob);
        } else {
          this.updateDependentArr('birthday', '');
        }
      },
    );
  }
  setYearOpenOption(val: any) {
    return this.setState({
      isShowYearOptionList: val,
    });
  }
  chooseYearOption(val: any) {
    const { month, date } = this.state;
    const errorMsgDOB = validateDateOfBirth(val, month, date, 6);
    this.setState(
      {
        year: val,
      },
      () => {
        this.setState({
          errorMsgDOB: errorMsgDOB,
        });
        if (!errorMsgDOB) {
          const dob = moment(`${val}${month}${date}`).format('YYYYMMDD');
          this.updateDependentArr('birthday', dob);
        } else {
          this.updateDependentArr('birthday', '');
        }
      },
    );
  }

  render() {
    const {
      dependentIndex,
      formDependentConfig: {
        formTitle,
        deleteIcon,
        relationship,
        name,
        gender,
        birthday,
        ageMonth,
      },
    } = this.props;
    const {
      isShowRelationshipOptionList,
      relationshipOptionList,
      relationshipState,
      nameState,
      isShowNameError,
      isShowNameCorrect,
      isShowGenderOptionList,
      genderOptionList,
      genderState,
      dateOptionList,
      monthOptionList,
      yearOptionList,
      date,
      isShowDateOptionList,
      month,
      isShowMonthOptionList,
      year,
      isShowYearOptionList,
      errorMsgDOB,
      isShowRelationshipError,
      isShowGenderError,
    } = this.state;

    return (
      <div className="offers-form-dependent-container row">
        <div className="col-12">
          {/* Title */}
          <div className="offers-form-dependent__title row">
            <div className="offers-form-dependent__title-label">
              {formTitle} {dependentIndex + 1}
            </div>
            <div
              className="offers-form-dependent__title-icon"
              style={{ backgroundImage: `url(${deleteIcon})` }}
              onClick={this.reduceDependentForm}
              data-enable-ga
              data-ga-type="button"
            ></div>
          </div>
          <div className="offers-form-dependent__aged">{ageMonth}</div>
          {/* Relationship */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={relationship.label}
                >
                  {relationship.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="row">
              <Dropdown
                dropDownClassName="col-12"
                optionList={relationshipOptionList}
                isShowOptionList={isShowRelationshipOptionList}
                setOption={this.setRelationshipOpenOption}
                value={relationshipState}
                title={t('RELATIONSHIP_PLACEHOLDER')}
                onClickAction={(val: any) => {
                  this.chooseRelationshipOption(val);
                }}
                onBlurOptions={this.onBlurRelationshipOption}
              />
            </div>
            {isShowRelationshipError && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {relationship.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Full name */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={name.label}
                >
                  {name.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="row">
              <div
                className={`emma-stylesheet-input col-12 ${
                  isShowNameError && name.errorMessage
                    ? 'emma-stylesheet-input-error'
                    : isShowNameCorrect
                    ? 'emma-stylesheet-input-success'
                    : ''
                }`}
              >
                <input
                  className={`emma-stylesheet-input-field col-12 ${
                    isShowNameError && name.errorMessage
                      ? 'emma-stylesheet-input-error-field'
                      : 'emma-stylesheet-input-success-field'
                  }`}
                  defaultValue={nameState}
                  value={nameState}
                  id={name.label}
                  placeholder={name.errorMessage}
                  type="text"
                  maxLength={100}
                  onChange={this.onBlurInputName}
                  onBlur={this.onBlurInputName}
                />
              </div>
            </div>
            {isShowNameError && name.errorMessage && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {name.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Gender */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={gender.label}
                >
                  {gender.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="row">
              <Dropdown
                dropDownClassName="col-12"
                optionList={genderOptionList}
                isShowOptionList={isShowGenderOptionList}
                setOption={this.setGenderOpenOption}
                value={genderState}
                title={t('GENDER_PLACEHOLDER')}
                onClickAction={(val: any) => {
                  this.chooseGenderOption(val);
                }}
                onBlurOptions={this.onBlurGenderOption}
              />
            </div>
            {isShowGenderError && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {gender.errorMessage}
                </div>
              </div>
            )}
          </div>
          {/* Date of Birth */}
          <div className="mg-top24">
            <div className="row">
              <div className="emma-stylesheet-label col-12">
                <label
                  className="emma-stylesheet-label__text"
                  htmlFor={birthday.label}
                >
                  {birthday.label}
                  <span className="offers-form-information__red-star">*</span>
                </label>
              </div>
            </div>
            <div className="offers-form-dependent__birthdate-container row">
              <Dropdown
                dropDownClassName="offers-form-dependent__birthdate"
                optionList={yearOptionList}
                isShowOptionList={isShowYearOptionList}
                setOption={this.setYearOpenOption}
                value={year}
                title={'YYYY'}
                onClickAction={(val: any) => {
                  this.chooseYearOption(val);
                }}
              />
              <div className="offers-form-dependent__birthdate-split">/</div>
              <Dropdown
                dropDownClassName="offers-form-dependent__birthdate"
                optionList={monthOptionList}
                isShowOptionList={isShowMonthOptionList}
                setOption={this.setMonthOpenOption}
                value={month}
                title={'MM'}
                onClickAction={(val: any) => {
                  this.chooseMonthOption(val);
                }}
              />
              <div className="offers-form-dependent__birthdate-split">/</div>
              <Dropdown
                dropDownClassName="offers-form-dependent__birthdate"
                optionList={dateOptionList}
                isShowOptionList={isShowDateOptionList}
                setOption={this.setDateOpenOption}
                value={date}
                title={'DD'}
                onClickAction={(val: any) => {
                  this.chooseDateOption(val);
                }}
              />
            </div>
            {errorMsgDOB && (
              <div className="row">
                <div className="emma-stylesheet-input-tip-error col-12">
                  {t(errorMsgDOB)}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  static mapStateToProps(state: any, ownProps: any) {
    return {};
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  OffersFormDependentView.mapStateToProps,
  OffersFormDependentView.mapDispatchToProps,
)(OffersFormDependentView);
